import { render, staticRenderFns } from "./IAGPolicySummary.vue?vue&type=template&id=070fb539&scoped=true"
import script from "./IAGPolicySummary.vue?vue&type=script&lang=js"
export * from "./IAGPolicySummary.vue?vue&type=script&lang=js"
import style0 from "./IAGPolicySummary.vue?vue&type=style&index=0&id=070fb539&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070fb539",
  null
  
)

export default component.exports